<template>
  <div style="width: 100%;" v-loading.body="loading">
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
            1099 REPORTING
          </el-row>
        </el-col>
        <el-col class="small">
            <a @click="showJson = ! showJson">.&nbsp;</a>
        </el-col>
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button plain @click="generateReport" :disabled="disableReportRun">
              Run report
            </el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
            Report Options
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Tax Year
        </el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.taxYear" :multiple="false" placeholder="">
            <el-option value="2017">2017</el-option>
            <el-option value="2018">2018</el-option>
            <el-option value="2019">2019</el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Company
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.company_id"
            :multiple="false" placeholder="All">
            <el-option
              v-for="(opt) in allCodes.companies"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="right">
          Production
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="selectedCodes.production_id"
            :multiple="false" placeholder="All">
            <el-option
              v-for="(opt) in allCodes.productions"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Invoice Date
        </el-col>
        <el-col :span="4">
          <DateField v-model="selectedCodes.doc_date_start" />
          <!-- <el-input v-model="selectedCodes.doc_date_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3" class="right">
          Invoice Date
        </el-col>
        <el-col :span="4">
          <DateField v-model="selectedCodes.doc_date_end" />
          <!-- <el-input v-model="selectedCodes.doc_date_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="2"></el-col>
        <el-col :span="1">
          <el-checkbox v-model="selectedCodes.showTaxableVendorsOnly"></el-checkbox>
        </el-col>
        <el-col :span="18" class="left">
          Show 1099-able Vendors Only? (Will ignore Vendors marked "NOT 1099")
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="2"></el-col>
        <el-col :span="1">
          <el-checkbox v-model="selectedCodes.showTaxableCostsOnly" justify="end"></el-checkbox>
        </el-col>
        <el-col :span="18" class="left">
          Show 1099 Tagged Only? (Will ignore Vendors without Tax Codes on Distributions)
        </el-col>
      </el-row>
      <!-- for 2020
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="2"></el-col>
        <el-col :span="1">
          <el-checkbox v-model="selectedCodes.hideCorporations"></el-checkbox>
        </el-col>
        <el-col :span="11" class="left">
          Hide Corporations? (Will ignore Vendors marked as "CORPORATION")
        </el-col>
      </el-row>
      -->
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Report Output
        </el-col>
        <el-col :span="4">
          <el-select v-model="reportOptions.format">
            <el-option
              v-for="(opt) in reportOutputFormats"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="headerRow">
        <el-col :span="3" class="right">
          Print Paper 1099s
        </el-col>
        <el-col :span="4">
          <el-select v-model="reportOptions.print1099" :multiple="false" @change="print1099Misc" placeholder="">
            <el-option value="No">No</el-option>
            <el-option value="Preprinted">IRS 1099 Pre-Printed Copies</el-option>
            <el-option value="Recipient">Recipient Copy B (no paper form needed)</el-option>
            <el-option value="Address">Recipient Copy B with Mailing Addresses (no paper form needed)</el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="Left"> This option prints 1099-MISC Copies (PDF Only).</el-col>
      </el-row>
      <div class="clear"></div>
      <el-row type="flex" align="middle" justify="end" class="headerRow">
        <el-col>
          <p><sup>*</sup> Required</p>
        </el-col>
      </el-row>
      <el-row v-if="showJson">
        <el-col>
          <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
        </el-col>
      </el-row>
      <el-row v-if="showJson">
        <el-col :span="1">
          <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
            Run Customized Report
          </el-button>
        </el-col>
      </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { reportMixins } from '@/Mixins/Reports'
  import DateField from '@/components/InputComponents/DateField.vue'
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'

  export default {
    name: 'TaxReport',
    components: { DateField },
    mixins: [ reportMixins ],
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'detail',
          sort: 'account',
          status: 'all',
          format: 'pdf',
          print1099: 'No'
        },

        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        allVendors: [],
        bankRelatedAccounts: [],     // Do not show bank related accounts
        selectedCodes: {
          taxYear: '2019',
          time_posted_start: undefined,
          time_posted_end: undefined,
          doc_date_start: '01-01-2019',
          doc_date_end: '12-31-2019',
          showTaxableVendorsOnly: false,
          showTaxableCostsOnly: false,
          hideCorporations: true,
          company_id: undefined,
          production_id: undefined,
          account_id: [],
          source_code_id: []
        },
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: '1099_detail'
        },

        vendors: undefined,

        transactionTypes: {     // Types of transactions and whether we need them or not
          'aps': { name: 'AP', include: true },
          'jes': { name: 'JE', include: true },
          'pcs': { name: 'PC', include: true },
          'cks': { name: 'CK', include: false },
          'pos': { name: 'PO', include: false }
        },
        unserializedData: {      // Raw data from API
          aps: {
            headers: {},
            lines: {}
          },
          jes: {
            headers: {},
            lines: {}
          },
          pcs: {
            headers: {},
            lines: {}
          },
          cks: {
            headers: {},
            lines: {}
          },
          pos: {
            headers: {},
            lines: {}
          }
        },
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        loading: false
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      includedTypes () {
        if (this.selectedCodes.source_code_id.length) this.transactionTypes.jes.include = true
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      accounts () {
        let accountsNew = []
        for (let i in this.allCodes.accounts) {
          if (this.allCodes.accounts[i].type.toLowerCase() === 'header') continue
          accountsNew[i] = this.allCodes.accounts[i]
          accountsNew[i]['display_name'] = this.allCodes.accounts[i]['code'] + ' - ' + this.allCodes.accounts[i]['name']
        }
        return accountsNew
      }
    },

    watch: {
    },

    methods: {
      resetComponent () {
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      print1099Misc () {
        // Set final options to true:
        this.selectedCodes.showTaxableVendorsOnly = true
        this.selectedCodes.showTaxableCostsOnly = true
        this.reportOptions.format = 'pdf'
        switch (this.reportOptions.print1099.toLowerCase()) {
          case 'preprinted':
            this.jasperSettings.reportName = '1099_misc_' + this.selectedCodes.taxYear + '_irs'
            break

          case 'address':
            this.jasperSettings.reportName = '1099_misc_' + this.selectedCodes.taxYear + '_address'
            break

          case 'recipient':
            this.jasperSettings.reportName = '1099_misc_' + this.selectedCodes.taxYear
            break

          default:
            this.jasperSettings.reportName = '1099_detail'
        }
      },
      updateReportType (type) {
        this.jasperSettings.reportName = '1099_' + type
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },
      buildCsvData (reportData) {
        return new Promise((resolve, reject) => {
          const map = {
            'Company': 'company_name',
            'Company Tax Id': 'company_tax_id',
            'Company Address 1': 'company_address1',
            'Company Address 2': 'company_address2',
            'Company City': 'company_city',
            'Company State': 'company_state',
            'Company Postal': 'company_postal',
            'Company Telephone': 'company_phone',
            'Vendor Number': 'vendor_number',
            'Vendor Name': 'vendor_name',
            'Vendor Tax ID': 'vendor_tax_id',
            'Vendor Tax Type': 'vendor_type',
            'Vendor Address 1': 'vendor_address1',
            'Vendor Address 2': 'vendor_address2',
            'Vendor City': 'vendor_city',
            'Vendor State': 'vendor_state',
            'Vendor Postal': 'vendor_postal',
            'Box 1 Total': '1099-1',
            'Box 2 Total': '1099-2',
            'Box 3 Total': '1099-3',
            'Box 4 Total': '1099-4',
            'Box 5 Total': '1099-5',
            'Box 6 Total': '1099-6',
            'Box 7 Total': '1099-7',
            'Box 8 Total': '1099-8',
            'State Withheld': 'withheld_total',
            'Total Taxable': 'taxable_total'
          }

          this.disableReportRun = false
          let finalCsv = this.createCsv(reportData.report.data, map)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },
      // Get data update with vendor tax id
      buildTaxReport () {
        return new Promise((resolve, reject) => {
          this.getAllVendors()
            .then(response => {
              if (!response || !Array.isArray(response)) return false

              this.allVendors = sortObjectByProperty(response, 'code')
            })
            .then(() => {
              return this.getReportData('taxreport')
            })
            .then((reportResult) => {
              if (!reportResult || !Array.isArray((reportResult.data.report || {}).data)) {
                this.createNotification('Info', 'No Data to Report. ', 'info')
                reject('No Data')
              }
              // Replace encrypted tax ID with decrypted tax ID.
              let fixedData = reportResult.data.report.data.map((vendorData) => {
                const a = vendorData.vendor_tax_id
                vendorData.vendor_tax_id = this.allVendors.find(({id}) => id === vendorData.vendor_id).tax_id || ''
                vendorData.vendor_tax_id_last4 = vendorData.vendor_tax_id ? 'x-' + String(vendorData.vendor_tax_id).slice(-4) : ''
                return vendorData
              })
              // Replace fixed data
              reportResult.data.report.data = fixedData
              resolve(reportResult.data)
            })
            .catch(error => {
              console.log(error)
            })
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.format === 'csv') {
          this.buildTaxReport()
            .then((resSorted) => {
              return this.buildCsvData(resSorted)
            })
            .then((resCsv) => {
              this.loading = false
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, '1099_Report')
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.buildTaxReport()
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              // console.log(report)
              // console.log(preview)
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    },

    beforeCreate () {
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
          return this.allCodes.banks
        })
        .then(banks => {
          banks.map(bank => {
            this.bankRelatedAccounts.push(bank.default_account_cash_id)
            this.bankRelatedAccounts.push(bank.default_account_clearing_id)
            this.bankRelatedAccounts.push(bank.default_account_deposits_id)
            this.bankRelatedAccounts.push(bank.default_account_discount_id)
          })
          const accountsNoBanks = this.allCodes.accounts.filter(acct => (acct.type.toLowerCase() !== 'header') && (!this.bankRelatedAccounts.includes(acct.id)))
          this.selectedCodes.account_id = accountsNoBanks.map(account => account.id)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })
    },

    mounted () {
    },

    beforeUnmount () {
      this.resetComponent()
    }
  }
</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>
